import { BaseCriterionSchemaProcessor } from './base-criterion-schema-processor';
import { updateOdataOptionsForDayTimeCriterionDay } from '../util/update-criterion-property-for-filter';

export class DayTimeCriterionSchemaProcessor extends BaseCriterionSchemaProcessor {
  constructor(options) {
    super(options, ['Criterion/DayTimeCriterion/Day']);
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);
    updateOdataOptionsForDayTimeCriterionDay(odataOptions);

    return odataOptions;
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    if (this.Permissions.IsPersonalizedOffersEnabled &&
      !this.Permissions.IsPersonalizedOffersV3Enabled) {
      updatedSchema.properties.CriterionCashback = {
        filterable: true,
        type: 'number',
        minimum: 0,
        maximum: 50,
        required: true,
      };
    }

    return updatedSchema;
  }
}
